import { inject, signal } from '@angular/core';
import { UserService } from '../../core/services/user.service';
import { Constructor } from '../../shared/files-management/models/mixins.model';

interface WithUserService {
  userService: UserService;
}

export function WithRoles<T extends Constructor<WithUserService>>(Base: T = class {} as any) {
  return class extends Base {
    readonly hasSupplierRole = signal(false);
    readonly isSupplierEngineer = signal(false);
    readonly isSupplierManager = signal(false);
    readonly hasProjectRole = signal(false);
    readonly isProjectEngineer = signal(false);
    readonly isAdmin = signal(false);
    readonly isSuperUser = signal(false);
    readonly userService = inject(UserService);

    constructor(...args: any[]) {
      super(...args);
      this.#setupRoles();
    }

    #setupRoles(): void {
      this.userService.currentUserRoles$.subscribe(roles => {
        this.isSupplierEngineer.set(roles.some(role => role.isSupplierEngineer));
        this.hasSupplierRole.set(roles.some(role => role.hasSupplierRole));
        this.hasProjectRole.set(roles.some(role => role.hasProjectRole));
        this.isSupplierManager.set(roles.some(role => role.isSupplierManager));
        this.isProjectEngineer.set(roles.some(role => role.isProjectEngineer));
        this.isAdmin.set(roles.some(role => role.isAdmin));
        this.isSuperUser.set(roles.some(role => role.isSuperUser));
      });
    }
  };
}
